/**
 * Users/AddAccount Controller
 *
 * 
 */

// the constructor for this object
function UsersAddAccountController() { }

// the object
UsersAddAccountController.prototype = {
    constructor: UsersAddAccountController,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        PortalHelper.debugMessage('Add Account Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // enable the submit button
        PortalHelper.enableButton('#add-account');

        PortalHelper.debugMessage('Add Account Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function()
    {   
        var self = this;
        $('#add-account-form').on('submit', function(e) {
            e.preventDefault();
            
            self._addAccount();
        });
    },
    
    // add an account to your user
    _addAccount: function()
    {
        $('.form').addClass('loading');
        
        var submissionData = {
            invoice_number: $('#invoice-number').val(),
            account_number: $('#account-number').val()
        };
        
        var addAccountRequest = new PortalRequest();
        addAccountRequest.errorElement = '.form-errors';
        addAccountRequest.successElement = '.form-success';
        addAccountRequest.makeRequest(
            '/accounts/add-account',
            submissionData,
            function(response) {
                
                // update the user data as a new account has been added
                PortalMain.PortalLogin.callback = function() {
                    $('.form').removeClass('loading');
                }
                PortalMain.PortalLogin.updateLoginData();
            },
            function(response) {
                $('.form').removeClass('loading');
            }
        )
    },
    
}